export enum FilterClearTypesEnum {
    DEFAULT_FILTERS,
    CLEAR_ALL
}
